import React from 'react';
import * as utils from "../utils";


//Inaktive samtykker
class ConsentInactive extends React.Component {


    render() {
        var consents = this.props.loans;
        var indexType = this.props.indexType;

        if (consents.errorMessage === undefined) {
            return <div id={'collapse' + indexType} className='panel-collapse collapse' aria-labelledby={'heading' + indexType}>
                <div>
                    <div className="d-xl-none">
                        <div key={indexType} className='card-body list padding-0'>
                            <table className="tableLoanCol">
                                <tbody>
                                {consents.map(function (consent, indexConsent) {
                                    return (
                                        <React.Fragment>
                                            <tr className={utils.tableStripes(indexConsent, false)}>
                                                <th>Virksomhet - organisasjonsnummer</th>
                                                <td className="bold">{consent.organization_name} - {consent.organization_no}</td>
                                            </tr>
                                            <tr className={utils.tableStripes(indexConsent, false)}>
                                                <th>Logg</th>
                                                <td>&nbsp;</td>
                                            </tr>
                                            <tr className={utils.tableStripes(indexConsent, false)}>
                                                <th>&nbsp;</th>
                                                <td className="bold">{utils.getConsentText(consent.active_consent, consent.to_date)}</td>
                                            </tr>
                                            {consent.log.map(function (log, logIndex) {
                                                var sisteRad = (logIndex + 1) === consent.log.length;
                                                return (
                                                    <tr className={utils.tableStripes(indexConsent, sisteRad)}>
                                                        <td>{log.timestamp}</td>
                                                        <td>{log.message}</td>
                                                    </tr>
                                                )
                                            })}
                                        </React.Fragment>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="d-none d-xl-block">
                        <div key={indexType} className='card-body list padding-0'>
                            <table className="tableConsentRow">
                                <tbody>
                                    <tr>
                                        <th className="headerLeft height35 widthConsentCol1">Virksomhet - organisasjonsnummer</th>
                                        <th className="headerLeft height35 widthConsentCol2">Logg</th>
                                        <th className="headerLeft height35 widthConsentCol3">&nbsp;</th>
                                    </tr>
                                </tbody>
                                {consents.map(consent => {
                                        return (
                                            <tbody key={consent.id}>
                                                <tr>
                                                    <td className="cellLeftBold height35">{consent.organization_name} - {consent.organization_no}</td>
                                                    <td className="cellLeft height35">&nbsp;</td>
                                                    <td className="cellLeftBold height35">{utils.getConsentText(consent.active_consent, consent.to_date)}</td>
                                                </tr>
                                                {consent.log.map(log => {
                                                    return (
                                                        <tr>
                                                            <td className="cellLeft height25 ">&nbsp;</td>
                                                            <td className="cellLeft height25 dotted-border-bottom">{log.timestamp}</td>
                                                            <td className="cellLeft height25 dotted-border-bottom">{log.message}</td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        )
                                    }
                                )}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        } else {
            return <div id={'collapse' + indexType} className='panel-collapse collapse' aria-labelledby={'heading' + indexType}>
                <div>
                    <span className="updatetMarkingInfo">!&nbsp;</span><span className="accordionMessage">Visning av samtykke er ikke tilgjengelig for øyeblikket, prøv igjen senere</span>
                </div>
            </div>
        }
    }
}

export default ConsentInactive;